import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeliveryLocationOverride } from './models/delivery-location-override.model';

@Injectable({
  providedIn: 'root'
})
export class DeliveryLocationOverrideService {

  constructor(private http$: HttpClient) { }

  getDeliveryLocationOverridesByMasterContactId(masterContactId: number) {
    return this.http$.get<DeliveryLocationOverride[]>(`/api/deliverylocationoverride/mastercontact/${masterContactId}`);
  }

  createDeliveryLocationOverride(data: { name: string; latitude: number; longitude: number; address: string, associatedMasterContactId: number | null }) {
    return this.http$.post('/api/deliverylocationoverride', data);
  }
}
